import FreePlanRequired, {
  FreePlanRequiredRef,
} from '@/components/Modals/FreePlanReqiured';
import React, { useRef } from 'react';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';


const OpenModalButton = () => {
  const modalRef = useRef<FreePlanRequiredRef>(null);
  const { data: user } = useCurrentUser();
  const plan_name = user?.subscription?.plan_name;
  return (
    <>
      <p id='button'>
        <button
          id='open-modal-button'
          className='button alert'
          onClick={() => (user?.role === 'user' && !plan_name) ? modalRef.current?.openModal() : window.location.href = "/groups/new" }
        >
          <span>Create a</span>
          <span id='stylized-skyshare' className='italicized'>
            <span id='stylized-sky'>SKY</span>
            SHARE
          </span>
          <span>Group</span>
        </button>
        <span className='text-customBlack'>or join existing groups below</span>
      </p>
      <FreePlanRequired ref={modalRef} />
    </>
  );
};

export default OpenModalButton;
